import script from "./CreateCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&setup=true&lang=js"

import "./CreateCampaign.vue?vue&type=style&index=0&id=46fdd914&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46fdd914"]])

export default __exports__